import { render, staticRenderFns } from "./ProjectSelection.vue?vue&type=template&id=1a3d21d4&"
import script from "./ProjectSelection.vue?vue&type=script&lang=js&"
export * from "./ProjectSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports